import { connect } from 'react-redux'
import * as OptionActions from '../../actions/option'

import SelectField from '../../components/inputs/SelectField'

const mapStateToProps = (state) => {
  const icaoHazardClasses = state.option.icaoHazardClasses

  const options = icaoHazardClasses
    .map((option) => ({
      id: option.id,
      field: option.field,
      label: option.description,
      value: option.name,
      description: option.description
    }))
    .sort((a, b) => a.label > b.label ? 1 : -1)

  return {
    options
  }
}

const mapDispatchToProps = (dispatch) => {
  const loadData = () => {
    return dispatch(OptionActions.retrieveIcaoHazardClasses())
  }

  return {
    loadData
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectField)
